import {
    isEmpty,
    isNil
} from 'lodash';

export function defaultIfEmpty(value: string | undefined, defaultValue: string): string {
    return isNil(value) || isEmpty(value) ? defaultValue : value;
}



// WEBPACK FOOTER //
// ./src/utils/string-utils.ts